export default {
  MAX_FILE_SIZE: process.env.VUE_APP_MAX_FILE_SIZE ? process.env.VUE_APP_MAX_FILE_SIZE * 1024 : 10 * 1024,
}